<template>
  <div class="fr-form">
    <h2 
      v-if="variant.heading" 
      :class="['fr-form__heading', formattedValue(variant.heading).match(/<br>/) ? 'fr-heading-word-wrap' : '']"
      v-html="formattedValue(variant.heading)"
    />
    <p 
      v-if="variant.intro"
      class="fr-form__intro"
    >
      {{ variant.intro }}
    </p>

    <template v-if="variant.stepFlow == 'automatic'">
      <fr-form-step 
        :step="1" 
        :fields="variant.steps[0]"
      />
      <template
        v-for="(step, index) in formStepsAuto"
        :key="`template-${index + 1}`"
      >
        <fr-form-step
          v-if="shouldShowStep(index)" 
          :step="index + 2" 
          :fields="step"
        />
      </template>
      <fr-form-controls v-if="isFinalStepShown" />
      <fr-phone-cta v-if="isFinalStepShown" />
      <fr-privacy-text v-if="isFinalStepShown" />
    </template>
    <template
      v-for="(step, index) in formSteps"
      v-else
      :key="`template-${index + 1}`"
    >
      <fr-form-step
        :step="index + 1" 
        :fields="step"
      />
    </template>
    <fr-form-controls v-if="variant.stepFlow !== 'automatic'" />
    <fr-phone-cta v-if="variant.stepFlow !== 'automatic'" />
    <fr-privacy-text v-if="variant.stepFlow !== 'automatic'" />
  </div>
</template>

<script>
import FrFormControls from '@/components/FrFormControls.vue'
import FrFormStep from '@/components/FrFormStep.vue'
import FrPrivacyText from '@/components/FrPrivacyText.vue'
import FrPhoneCta from '@/components/FrPhoneCta.vue'

export default {

  name: 'FormRenderer',

  components: {
    FrFormControls,
    FrFormStep,
    FrPrivacyText,
    FrPhoneCta
  },
  inject: ['store'],

  data() {
    return {
      shownSteps: []
    };
  },

  computed: {
    variant() {
      return this.store.getFormVariant
    },

    formSteps() {
      return this.store.getFormSteps
    },

    //return the form steps without the first one
    formStepsAuto() {
      return this.formSteps.slice(1)
    },

    currentFormStep() {
      return this.store.getCurrentFormStep
    },

    isSubmitting() { 
      return this.store.getIsSubmitting 
    },

    /**
     * This function checks if all fields are valid on the current step before displaying the next step - functioning as the handleNextStep essentially.
     */
     allFirstStepFieldsValid() {
      return this.isStepValid(0)
    },

    /** 
     * This function checks if the final step is shown or not.
     */
    isFinalStepShown() {
      return this.shownSteps.includes(this.formStepsAuto.length - 1)

    },
  },

    watch: {
    allFirstStepFieldsValid(newVal, oldVal) {
      if(newVal && this.variant.stepFlow == 'automatic') {
        this.store.incrementFormStep()
      }
      //if the first step is no longer valid, we need to decrement the form step
      if(oldVal == true && newVal == false && this.variant.stepFlow == 'automatic') {
        this.store.decrementFormStep()
      }
    }
  },

  mounted() {
    this.initValidation()
  },
  methods: {

    initValidation(){
      const { schema, labelLut } = this.store.generateStepsSchema(this.formSteps)
      this.store.setSchemaObject({ schema: schema, lut: labelLut, errors: {} })
      
    },

    /**
     * This function checks if the current step should be shown or not.
     */
    shouldShowStep(stepIndex) {
      //if the form is submitting, always show
      if(this.isSubmitting) {
        return true
      }

      //if the current step is within the shownSteps array, keep displaying it
      if(this.shownSteps.includes(stepIndex)) {
        return true
      }

      //if the current step is not within the shownSteps array, check if it should be shown
      const shouldShow = this.isStepValid(stepIndex)
      if(shouldShow) {
        this.shownSteps.push(stepIndex)
      }

      return shouldShow

    },

    /**
     * This function checks if all fields are valid on the current step before displaying the next step - functioning as the handleNextStep essentially.
     */
    isStepValid(stepIndex) {
      
      //this is an array of booleans that checks if the fields on the step are valid or not with !errors
      let isStepValidArray = this.variant.steps[stepIndex].map(field => {
        //if the field has a value from initialization, it can pass validation- this is designed for the programs field
        if(this.store.getSubmitObject[field.meta.submitKey] !== "") {
          return true
        }
        return !this.store.fieldHasErrors(field.component) && this.store.fieldHasBeenValidated(field.component)
      })

      //reduce the array of booleans to a single boolean value
      let isValid = isStepValidArray.reduce((accumulated, current) => accumulated && current)

      return isValid
    },

    //Convert string to Encrypt html value
    formattedValue(content) {
      // Convert all types of line breaks to <br> tags
      // Handles: \r\n (Windows), \n (Unix/Linux/Mac), \r (old Mac)
      return content.replace(/\r\n|\r|\n/g, '<br>')
    },
  }
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}

.fr-heading-word-wrap {
  word-break: break-word;
}
</style>
